const styles = {
  // Layout
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },

  // Status card
  statusCard: {
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  statusHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: '16px',
  },
  statusTitleRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    marginBottom: '8px',
  },
  pendingText: {
    color: '#b7791f',
  },
  priceSection: {
    textAlign: 'right',
  },
  priceLine: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'baseline',
    gap: '4px',
  },

  // Details grid
  detailsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
  },
  detailLabel: {
    color: 'gray',
  },
  detailValue: {
    marginTop: '4px',
    fontSize: '14px',
    fontWeight: 'bold',
  },

  // Benefits
  benefitsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px',
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  benefitItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  // Footer
  footerActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    gap: '8px',
  },
} as const

export default styles
